// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "paperRoot-3EKoo";
var _4 = "title-1QBJH";
var _5 = "tabs__wrapper-3u06r";
var _6 = "tabs__segments-1yjJh";
var _7 = "tabs__languages-2D4dq";
var _8 = "tab-S7Cjm";
var _9 = "loaderWrp-3Sr2p";
var _a = "loader-TptUm";
var _b = "errorWrp-1gl55";
var _c = "errorTitle-1cC7k";
var _d = "errorText-2ZNZC";
var _e = "fareConditionsContent-1OeWv";
export { _1 as "__esModule", _2 as "mobile", _3 as "paperRoot", _4 as "title", _5 as "tabs__wrapper", _6 as "tabs__segments", _7 as "tabs__languages", _8 as "tab", _9 as "loaderWrp", _a as "loader", _b as "errorWrp", _c as "errorTitle", _d as "errorText", _e as "fareConditionsContent" }
export default { "__esModule": _1, "mobile": _2, "paperRoot": _3, "title": _4, "tabs__wrapper": _5, "tabs__segments": _6, "tabs__languages": _7, "tab": _8, "loaderWrp": _9, "loader": _a, "errorWrp": _b, "errorTitle": _c, "errorText": _d, "fareConditionsContent": _e }
